import { forwardRef } from 'react';

import { Box, useTheme } from '@mui/material';

const CopyIcon = forwardRef<SVGSVGElement, any>((props, ref) => {
  const theme = useTheme();
  return (
    <Box
      component="svg"
      width="100%"
      height="100%"
      fill="currentColor"
      color={theme.palette.text.secondary}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...props}
    >
      <g clipPath="url(#clip0_534_14975)">
        <path
          d="M10.3334 0.666668H3.40745C2.71486 0.666668 2.14819 1.26667 2.14819 2V10.6667C2.14819 11.0333 2.43153 11.3333 2.77782 11.3333C3.12412 11.3333 3.40745 11.0333 3.40745 10.6667V2.66667C3.40745 2.3 3.69079 2 4.03708 2H10.3334C10.6797 2 10.963 1.7 10.963 1.33333C10.963 0.966668 10.6797 0.666668 10.3334 0.666668ZM12.8519 3.33333H5.92597C5.23338 3.33333 4.66671 3.93333 4.66671 4.66667V14C4.66671 14.7333 5.23338 15.3333 5.92597 15.3333H12.8519C13.5445 15.3333 14.1112 14.7333 14.1112 14V4.66667C14.1112 3.93333 13.5445 3.33333 12.8519 3.33333ZM12.2223 14H6.5556C6.2093 14 5.92597 13.7 5.92597 13.3333V5.33333C5.92597 4.96667 6.2093 4.66667 6.5556 4.66667H12.2223C12.5686 4.66667 12.8519 4.96667 12.8519 5.33333V13.3333C12.8519 13.7 12.5686 14 12.2223 14Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_534_14975">
          <rect width="15.1111" height="16" fill="white" transform="translate(0.888916)" />
        </clipPath>
      </defs>
    </Box>
  );
});

export default CopyIcon;
